import { format, isValid, parseISO } from "date-fns";
import { dropdownForPayload } from "./locationDropdowns";

function formatProductionDateForApi(date) {
  if (!date) {
    return null;
  }

  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(date)) {
    return date;
  }

  const parsed = date instanceof Date ? date : parseISO(date);
  if (!isValid(parsed)) {
    return null;
  }

  return format(parsed, "yyyy-MM-dd HH:mm:ss");
}

export function buildStartManufacturingPayload(values) {
  const payload = {
    recipe_id: values.recipe_id ?? null,
    manufactured_product_recipe_id: values.manufactured_product_recipe_id ?? null,
    production_date: formatProductionDateForApi(values.production_date),
    plu: values.plu,
  };

  if (values.product_id) {
    payload.product_id = values.product_id;
  }

  return payload;
}

export function buildUpdateManufacturedProductPayload(values) {
  const manufacturedProductId =
    values.manufactured_product_id ?? values.id;

  return {
    manufactured_product_id: manufacturedProductId,
    supervisor: values.supervisor,
    employee_1: values.employee_1,
    employee_2: values.employee_2,
    claims: values.claims ?? [],
    location: dropdownForPayload(values.location),
    production_room: dropdownForPayload(values.production_room),
    production_room_temperature: values.production_room_temperature ?? "",
    raw_product_temperature: values.raw_product_temperature ?? "",
    product_id: values.product_id,
    plu: values.plu,
    product_name: values.product_name,
    description_en: values.description_en ?? "",
    description_fr: values.description_fr ?? null,
    new_weight:
      values.new_weight != null ? String(values.new_weight) : "0",
    lot_number: values.lot_number ?? "",
    export_eligible: values.export_eligible ?? null,
    new_product_temperature: values.new_product_temperature ?? "",
    allergens_en: values.allergens_en ?? "",
    allergens_fr: values.allergens_fr ?? null,
    corrective_action: values.corrective_action ?? null,
    certification_type: values.certification_type ?? null,
    recipe_id: values.recipe_id ?? null,
    manufactured_product_recipe_id:
      values.manufactured_product_recipe_id ?? null,
    required_total_raw_material: values.required_total_raw_material ?? null,
    packing_size: values.packing_size ?? null,
    production_date: formatProductionDateForApi(values.production_date),
    status: values.status,
  };
}

export function getManufacturedProductApiErrorMessage(
  callResult,
  fallback = "Something went wrong, please try again later.",
) {
  return callResult?.data?.message || fallback;
}
